import React from 'react'
import { connect } from 'react-redux'
import {
    ajaxArchiveFeedback,
    ajaxAssignRatingPageEmployee,
    ajaxCheckedFeedbackStatus,
    ajaxCreateNote,
    ajaxDeleteNote,
    ajaxFeedback,
    ajaxFeedbackFilterV2,
    ajaxForwardEmails,
    ajaxForwardTexts,
    ajaxMaskedCall,
    ajaxUpdateFeedbackDepartment,
    ajaxUpdateFeedbackStatus,
    ajaxUpdateNote,
    deselectFeedback,
    getDepartmentFilter,
    getRatingsFilter,
    getTagFilter,
    setChatAnyway,
    setSelectedFeedback
} from './redux/FeedbackRedux'
import TextMessageForward from './feedbackdetail/TextMessageForward'
import ForwardFeedback from './feedbackdetail/ForwardFeedback'
import EditNote from './feedbackdetail/EditNote'
import ForwardHistory from './feedbackdetail/ForwardHistory'
import MaskedCallModal from './v2/MaskedCallModal'
import PendingModal from './feedbackdetail/PendingModal'
import PotentialRecipientsEmail from './feedbackdetail/PotentialRecipientsEmail'
import PotentialRecipientsSMS from './feedbackdetail/PotentialRecipientsSMS'
import DownloadXLS from './feedbackdetail/DownloadXLS'
import AssignRatingPageEmployee from './feedbackdetail/AssignRatingPageEmployee'
import Alert from './Alert'

class Modal extends React.Component {

	constructor(props) {
		super(props);
		this.handleButton1Click = this.handleButton1Click.bind(this);
		this.handleButton2Click = this.handleButton2Click.bind(this);
		this.fieldsAreEmpty = this.fieldsAreEmpty.bind(this);
		this.setSubmitting = this.setSubmitting.bind(this);
		this.handleModalHidden = this.handleModalHidden.bind(this);
		this.modalRef = React.createRef();
		this.state = { custom_text: '', chatAnyway: false, resolveNote: '', hasNoTextError: false, submitting: false };
	}

	componentDidMount() {
		jQuery(this.modalRef.current).on('hidden.bs.modal', this.handleModalHidden);
	}

	componentWillUnmount() {
		jQuery(this.modalRef.current).off('hidden.bs.modal', this.handleModalHidden);
	}

	handleModalHidden() {
		this.setSubmitting(false);
	}

	setSubmitting(submitting) {
		this.setState({submitting: submitting});
	}

	handleResolveNoteTextChange(event) {
		this.setState({resolveNote: event.target.value});
		jQuery("#resolve-internal-note").css("height", Math.max(Math.min(document.getElementById("resolve-internal-note").scrollHeight, 220), 100) + "px");
	}

	handleButton1Click(event) {
		let feedback_id;
        const type = this.props.modal.button_1_id;
        if (type === 'cancel') {
			jQuery('.modal').modal('hide');
		}

		if (type === 'deleteNote') {
            const notes_id = this.props.selected_note.note.notes_id;
            feedback_id = this.props.feedback.feedback_id;
			this.props.dispatch(ajaxDeleteNote(notes_id, feedback_id));
			jQuery('.modal').modal('hide');
		}

		if (type === 'sendQuiet') {
			const feedback_id = this.props.feedback.feedback_id;
			const department_id = window.findDepartment;
			this.props.dispatch(ajaxUpdateFeedbackDepartment(feedback_id, department_id, this.props.state, "Quiet"));
			jQuery('.modal').modal('hide');
		}

		if (type === 'chatAnyway') {
			this.setState({ custom_text: '', chatAnyway: true });
			this.props.dispatch(setChatAnyway({ chatAnyway: true }));
			jQuery('.modal').modal('hide');
		}
	}

	handleButton2Click(event) {
        let hide_info;
        const type = this.props.modal.button_2_id;
        if (type === 'archive') {
			this.props.dispatch(ajaxArchiveFeedback(this.props.feedback_id));
			jQuery('.modal').modal('hide');
			setTimeout(() => {
				jQuery('body').find('.alert').hide();
				this.props.dispatch(ajaxFeedbackFilterV2(false, true));
				if (this.props.state.feedback_detail != null) {
					let loadThisFeedback = this.props.state.feedback_detail.next_id || this.props.state.feedback_detail.prev_id;
					if (loadThisFeedback !== null) {
						this.props.dispatch(setSelectedFeedback(loadThisFeedback));
						this.props.dispatch(ajaxFeedback(loadThisFeedback));
					} else {
						this.props.dispatch(deselectFeedback());
					}
				}
			}, 1000);
		}

        if (type === 'assignRatingPageEmployee') {
            const business_id = this.props.feedback.business.business_id;
            const feedback_id = this.props.feedback.feedback_id;
            const rating_page_employee_id = jQuery('#rating-employee-select').val();
            if (business_id !== null && feedback_id !== null && rating_page_employee_id !== null) {
                this.props.dispatch(ajaxAssignRatingPageEmployee(business_id, feedback_id, rating_page_employee_id));
            }
            jQuery('.modal').modal('hide');
        }

		if (type === 'sendLoud') {
            const feedback_id = this.props.feedback.feedback_id;
            const department_id = window.findDepartment;
            this.props.dispatch(ajaxUpdateFeedbackDepartment(feedback_id, department_id, this.props.state, "Loud"));
			jQuery('.modal').modal('hide');
		}

		if (type === 'initiateMaskedCall') {
			this.props.dispatch(ajaxMaskedCall(this.props.feedback, this.props.state.isMobileVersion));
		}

		if (type === 'cancel') {
			jQuery('.modal').modal('hide');
		}

		// Handle Text Forwards
		if (type === 'send') {
			jQuery('body').find('.modal-warning').hide();
			if (this.fieldsAreEmpty() === false || this.props.current_forwards.length < 1) {
				jQuery('body').find('.modal-warning').show();
			} else if (this.fieldsAreEmpty() === true) {
                hide_info = false;
                hide_info = !!jQuery('#hide-userinfo').prop('checked');
				this.props.dispatch(ajaxForwardTexts(this.props.feedback.feedback_id, this.props.current_user, this.props.current_forwards, (this.state.custom_text !== "" ? this.state.custom_text : null), hide_info));
				this.setState({ custom_text: "" });
				jQuery('.modal').modal('hide');
			}
		}

		// Handle Email Forwards
		if (type === 'email') {
			if (this.fieldsAreEmpty() === false || this.props.all_forwards.length < 1) {
				return jQuery('body').find('.modal-warning').show();
			}
			hide_info = false;
			hide_info = !!jQuery('#hide-userinfo').prop('checked');
			this.props.dispatch(ajaxForwardEmails(
				this.props.feedback,
				this.props.feedback.feedback_id,
				this.props.current_user,
				(this.state.custom_text !== "" ? this.state.custom_text : null),
				hide_info,
				this.props.all_forwards));
			this.setState({ custom_text: "" });
			jQuery('.modal').modal('hide');
		}

		// Handle Email & Text Forwards
		if (type === 'forward') {
			// check if any forwards
			if (this.fieldsAreEmpty() === false || this.props.all_forwards.length < 1) {
				return jQuery('body').find('.modal-warning').show();
			}

			// check if Hide User Info was checked
			hide_info = !!jQuery('#hide-userinfo').prop('checked');

			// handle email forwards
			const hasEmail = this.props.all_forwards.some(item => item.email !== null && item.email !== undefined);
			if (hasEmail) {
				this.props.dispatch(ajaxForwardEmails(
					this.props.feedback,
					this.props.feedback.feedback_id,
					this.props.current_user,
					(this.state.custom_text !== "" ? this.state.custom_text : null),
					hide_info,
					this.props.all_forwards));
			}

			// handle text forwards
			const hasRecipient = this.props.all_forwards.some(item => item.recipient !== null && item.recipient !== undefined);
			if (hasRecipient) {
				this.props.dispatch(ajaxForwardTexts(
					this.props.feedback.feedback_id,
					this.props.current_user,
					this.props.all_forwards,
					(this.state.custom_text !== "" ? this.state.custom_text : null),
					hide_info));
			}

			// reset state and hide modal
			this.setState({ custom_text: "" });
			jQuery('.modal').modal('hide');
		}

		if (type === 'updateNote') {
			this.props.dispatch(ajaxUpdateNote(this.props.selected_note.note.notes_id, this.props.selected_note_text));
			jQuery('.modal').modal('hide');
		}

		if (type === 'setResolved') {
			if (this.state.submitting) {
				return;
			}
			if (this.props.state.business && this.props.state.business.options && this.props.state.business.options.resolve_unresponded_note && 0 === this.props.feedback.chats.length) {
				if (this.state.resolveNote.trim().length === 0) {
					this.setState({hasNoTextError: true}, () => {
						jQuery('body').find('.modal-warning').show();
					});
					return;
				} else {
					this.setSubmitting(true);
					this.props.dispatch(ajaxCreateNote(
						this.state.resolveNote.trim(),
						this.props.state.current_user,
						this.props.state?.feedback_detail?.feedback_id || this.props.feedback_id,
						null,
						this.props.state, () => {
						this.props.dispatch(ajaxUpdateFeedbackStatus(this.props.feedback.feedback_id ?? this.props.feedback.id, window.feedbackStatus.Resolved.value, this.props.state));
						jQuery('.modal').modal('hide');
					}, 'modal')).fail(() => { this.setSubmitting(false); });
					return;
				}
			}
			this.props.dispatch(ajaxUpdateFeedbackStatus(this.props.feedback.feedback_id ?? this.props.feedback.id, window.feedbackStatus.Resolved.value, this.props.state));
			jQuery('.modal').modal('hide');
		}

		if (type === 'setResolvedAll') {
			if (this.state.submitting) {
				return;
			}
			if (this.props.state.business.options && this.props.state.business.options.resolve_unresponded_note) {

                // Bulk Resolve Action
                if (this.props.modal.modal_type === "bulkResolve") {
                    const autoGenNote = __('Automatically generated note: This feedback was Resolved using Bulk Resolve.')

                    this.setSubmitting(true);
                    this.props.dispatch(
                        ajaxCreateNote(
                            autoGenNote,
                            this.props.state.current_user,
                            null,
                            null,
                            this.props.state,
                            () => {
                                this.props.dispatch(ajaxCheckedFeedbackStatus(window.feedbackStatus.Resolved.value, this.props.state))
                                jQuery('.modal').modal('hide');
                            },
                            'modal'
                        )
                    ).fail(() => { this.setSubmitting(false); });

                    return;
                }

				if (this.state.resolveNote.trim().length === 0) {
					this.setState({hasNoTextError: true}, () => {
						jQuery('body').find('.modal-warning').show();
					});
				} else {
					this.setSubmitting(true);
					this.props.dispatch(ajaxCreateNote(this.state.resolveNote.trim(), this.props.state.current_user, null, null, this.props.state, () => {
						this.props.dispatch(ajaxCheckedFeedbackStatus(window.feedbackStatus.Resolved.value, this.props.state))
						jQuery('.modal').modal('hide');
					}, 'modal')).fail(() => { this.setSubmitting(false); });
				}
				return;
			}

			this.props.dispatch(ajaxCheckedFeedbackStatus(window.feedbackStatus.Resolved.value, this.props.state))
			jQuery('.modal').modal('hide');
		}

		if (type === 'setPending') {
            if (this.state.submitting) {
                return;
            }
            const setPending = () => {
                this.props.dispatch(ajaxUpdateFeedbackStatus(this.props.feedback.feedback_id ?? this.props.feedback.id, window.feedbackStatus.Pending.value, this.props.state));
                jQuery('.modal').modal('hide');
            };

            // if note added make sure to save it
            const addedNote = document.querySelector(".note-textarea")?.value.trim();
            if (addedNote) {
                this.setSubmitting(true);
                this.props.dispatch(ajaxCreateNote( "Reason for setting to pending: " + addedNote, this.props.state.current_user, this.props.feedback_id, null, this.props.state, setPending, 'modal'))
                    .fail(() => { this.setSubmitting(false); });
            } else {
                setPending();
            }
		}

		if (type === "export_xls_send_btn") {
            let email = $("#recipient_email").val();
			const emailRegex = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

			if (!emailRegex.test(email)) {
				document.querySelector("#recipient_email").reportValidity();
				return;
			}

            let data = {
				user_id: this.props.state.current_user,
				business_id: this.props.state?.business?.business_id || null,
				timeframe: this.props.state.timeframe,
				status: this.props.state.status,
				tfstart: this.props.state.timeframe_prev,
				tfend: this.props.state.timeframe_next,
				search: this.props.state.query,
				send_email: email,
			};

			let filterRating = getRatingsFilter();
			if (filterRating !== null && filterRating !== 'undefined') {
				data.filterRating = JSON.stringify(filterRating);
			}

			let filterDepartment = getDepartmentFilter()
			if (filterDepartment !== null && filterDepartment !== 'undefined') {
				data.filterDepartment = JSON.stringify(filterDepartment)
			}

			let filterTag = getTagFilter()
			if (filterTag !== null && filterTag !== 'undefined') {
				data.filterTag = JSON.stringify(filterTag)
			}

			// used for both single business and MSA Dashboard
			let url = data.business_id ? "/business/feedbacks/export?" : "/dashboard/feedbacks/export?";
			for (let d in data) {
				url += d;
				url += "=";
				url += data[d];
				url += "&";
			}

            document.getElementById(type).disabled = true;
            fetch(url, { method: 'GET' }).then(response => {
                response.json().then(data => {
                    window.displayMessage(data.message, 'success');
                }).catch(err => {
                    console.error(err);
                })
            }).catch(err => {
                console.error(err);
                window.displayMessage('There was an error preparing your export', 'danger');
            }).finally(() => {
                document.getElementById(type).disabled = false;
                jQuery('.modal').modal('hide');
            });
		}
	}

	handleTextInput(event) {
		this.setState({
			custom_text: event.target.value
		});
	}

	fieldsAreEmpty() {
		return (jQuery('body').find('.forward-number').val() === "" && jQuery('body').find('.forward-nickname').val() === "");
	}

	render() {
		const resolveRespondedNote = this.props.modal.modal_id === "statusModal" && this.props.state.business && this.props.state.business.options && this.props.state.business.options.resolve_unresponded_note;

		return (
			<div className="modal fade" tabIndex="-1" role="dialog" id={this.props.modal.modal_id} ref={this.modalRef}>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h4 className="modal-title">{this.props.modal.modal_title}</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>

						<div className="modal-body">
							{this.props.modal.modal_body === "maskedCall" ?
								<MaskedCallModal />
								:
								null
							}

							{this.props.modal.modal_body === "renderTextForward" &&
								<TextMessageForward handleTextInput={this.handleTextInput.bind(this)} custom_text={this.state.custom_text} />
							}

							{this.props.modal.modal_body === "renderAssignRatingPageEmployee" &&
								<AssignRatingPageEmployee />
							}

							{this.props.modal.modal_body === "renderEmailForward" &&
								<ForwardFeedback
                                    handleTextInput={this.handleTextInput.bind(this)}
                                    custom_text={this.state.custom_text}
                                />
							}

                            {this.props.modal.modal_body === "renderEmailForwardSummary" &&
                                <ForwardFeedback
                                    handleTextInput={this.handleTextInput.bind(this)}
                                    custom_text={this.state.custom_text}
                                    emailOnly={true}
                                    existingRecipients={this.props.existingRecipients}
                                    businessId={this.props.state.business.business_id}
                                    contacts={this.props.contacts}
                                    employees={this.props.employees}
                                />
                            }

							{this.props.modal.modal_body === "renderForwardHistory" &&
								<ForwardHistory />
							}

							{this.props.modal.modal_body === "renderEditNote" &&
								<EditNote />
							}

							{this.props.modal.modal_body === "pendingModal" &&
								<PendingModal feedback={this.props.feedback_id} submitting={this.state.submitting} onSubmittingChange={this.setSubmitting}/>
							}

							{this.props.modal.modal_body === "potentialRecipientsEmail" &&
								<PotentialRecipientsEmail />
							}

							{this.props.modal.modal_body === "potentialRecipientsSMS" &&
								<PotentialRecipientsSMS />
							}

							{this.props.modal.modal_body === "exportXls" &&
								<DownloadXLS />
							}

							{(resolveRespondedNote && this.props.modal.modal_type === 'm3') ? <>
									<p>{__('You are marking a Feedback as "Resolved" where a chat/text response has been requested but no chat has been initiated by an employee. If a response to the sender of the Feedback is still needed please click “Cancel and Go Back”.')}</p>
									<br />
									<p>{__('If you have already responded to the Feedbacker through another method, or there is a reason not to respond, please include an internal note below about why you are marking the Feedback as "Resolved" without responding through this platform.')}</p>
									<br />
									<div className="input-group feedback-form-control mb-0 border">
										<div className="input-group-prepend">
											<span className="input-group-text"><i className="fas fa-comment"></i></span>
										</div>
										<textarea id="resolve-internal-note" onChange={this.handleResolveNoteTextChange.bind(this)} value={this.state.resolveNote}
											style={{ resize: "none" }} rows={4} className="form-control lg-control"
											placeholder={ __('Enter an internal note of why this Feedback is being marked as "Resolved" without a response') + "..." } aria-label="Add a Message..." />
									</div>
									{this.state.hasNoTextError && <p className="alert alert-sm alert-danger modal-warning mt-1">{ __('This field may not be empty') }.</p>}
								</> : <></>}

							<Alert alert={this.props.state.alert.alert} location={'modal'}/>

							{this.props.modal.modal_body !== "renderTextForward"
								&& this.props.modal.modal_body !== "renderAssignRatingPageEmployee"
								&& this.props.modal.modal_body !== "renderEmailForward"
                                && this.props.modal.modal_body !== "renderEmailForwardSummary"
								&& this.props.modal.modal_body !== "renderEditNote"
								&& this.props.modal.modal_body !== "renderForwardHistory"
								&& this.props.modal.modal_body !== "pendingModal"
								&& this.props.modal.modal_body !== "potentialRecipientsEmail"
								&& this.props.modal.modal_body !== "potentialRecipientsSMS"
								&& this.props.modal.modal_body !== "maskedCall"
								&& this.props.modal.modal_body !== "exportXls"
								&& (!resolveRespondedNote || this.props.modal.modal_type === 'm2' || this.props.modal.modal_type === "bulkResolve") &&
								<p dangerouslySetInnerHTML={{ __html: this.props.modal.modal_body }} />
							}
						</div>

						<div className="modal-footer" style={{justifyContent: this.props.modal.modal_body === "pendingModal" ? "flex-start" : "flex-end"}}>
							{this.props.modal.button_1_id && <button type="button" onClick={this.handleButton1Click} className={"btn btn-md btn-" + this.props.modal.button_1_class} id={this.props.modal.button_1_id}>{(resolveRespondedNote && this.props.modal.modal_type === "m3") ? __('Cancel and Go Back') : this.props.modal.button_1_text}</button>}
							{this.props.modal.button_2_id === 'dialMaskedCall' && <a href={`tel:${this.props.state.proxyService.data.proxy}`} className='btn btn-md btn-primary'>{this.props.modal.button_2_text}</a>}
							{this.props.modal.button_2_id && this.props.modal.button_2_id !== 'dialMaskedCall' && <button type="button" onClick={this.handleButton2Click} disabled={this.state.submitting} className={"btn btn-md btn-" + this.props.modal.button_2_class} id={this.props.modal.button_2_id}>{resolveRespondedNote && this.props.modal.modal_type === "m3" ? __('Mark as “Resolved” with the internal note above') : this.props.modal.button_2_text}</button>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    if (state.feedback_detail) {
		return {
			modal: state.modal,
			feedback_id: state.feedback_detail.feedback_id,
			current_user: state.current_user,
			current_forwards: state.current_forwards,
			current_email_forwards: state.current_email_forwards,
			all_forwards: state.all_forwards,
			forward_text: state.forward_text,
			feedback: state.feedback_detail,
			selected_note: state.selected_note,
			selected_note_text: state.selected_note_text,
			state: state,
			chatAnyway: state.chatAnyway,
		}
	} else if (state.selected_feedback_modal) {
		return {
			modal: state.modal,
			feedback_id: state.selected_feedback_modal.id,
			current_user: state.current_user,
			current_forwards: state.current_forwards,
			current_email_forwards: state.current_email_forwards,
			all_forwards: state.all_forwards,
			forward_text: state.forward_text,
			feedback: state.selected_feedback_modal,
			selected_note: state.selected_note,
			selected_note_text: state.selected_note_text,
			state: state,
			chatAnyway: state.chatAnyway,
		}
	}

	return { modal: state.modal, state: state, chatAnyway: state.chatAnyway }
}

export default connect(mapStateToProps)(Modal)
